import React from "react";
import { _getBaseUrl, _capitalized } from "../utils/helper";

const CardPeople = ({ data, ...props }) => {
  const imageURL =
    data.image ||
    _getBaseUrl("src/assets/profile-picture-placeholder.png", true);

  return (
    <a className="card--people group" href={data.permalink}>
      <div className="aspect-[14/18] rounded-md overflow-hidden relative mb-6">
        <img
          src={imageURL}
          alt={data.image_alt}
          className="absolute top-0 left-0 w-full h-full object-cover duration-500 hover:scale-105 transition-all"
        />
      </div>

      <div className="text-mobileS md:text-desktopS transition-all duration-200 group-hover:text-ideaBlue100">
        <div className="font-semibold ">{data.name}</div>
        {data.position && <div className="">{data.position}</div>}
      </div>
    </a>
  );
};

export default CardPeople;
